import { render, staticRenderFns } from "./AlbumsWall.vue?vue&type=template&id=0457e3b8&scoped=true"
import script from "./AlbumsWall.vue?vue&type=script&lang=js"
export * from "./AlbumsWall.vue?vue&type=script&lang=js"
import style0 from "./AlbumsWall.vue?vue&type=style&index=0&id=0457e3b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457e3b8",
  null
  
)

export default component.exports